import { render, staticRenderFns } from "./OperateCard.vue?vue&type=template&id=35c756c5&scoped=true"
import script from "./OperateCard.vue?vue&type=script&lang=js"
export * from "./OperateCard.vue?vue&type=script&lang=js"
import style0 from "./OperateCard.vue?vue&type=style&index=0&id=35c756c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c756c5",
  null
  
)

export default component.exports